import React from 'react';
import { Root, ChipContainer, RemoveIconContainer } from './styles';
import RemoveIconWhite from '../../common/icons/removeIconWhite';
import { CSSProperties } from 'styled-components';

export interface IState { }

export interface IProps {
    items: string[];
    handleRemove: (index: number) => void;
    style?: CSSProperties;
    chipStyle?: CSSProperties;
    removeIconStyle?: CSSProperties;
}

const Chips: React.FC<IProps> = (props) => {

    return (
        <Root style={props.style} >
            {
                props.items.map((item: string, index: number) => {
                    return (
                        <ChipContainer key={index} style={props.chipStyle} >
                            {item}
                            <RemoveIconContainer onClick={() => props.handleRemove(index)} style={props.removeIconStyle}>
                                <RemoveIconWhite style={{marginTop:'-1px'}} />
                            </RemoveIconContainer>
                        </ChipContainer>
                    )
                })
            }
        </Root>
    );
}

export default Chips;